import { render, staticRenderFns } from "./ClaimsReturnsMenu.vue?vue&type=template&id=491df698"
import script from "./ClaimsReturnsMenu.vue?vue&type=script&lang=js"
export * from "./ClaimsReturnsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports